<template>
    Support
</template>
<script>
export default {
    name:'Support',
    
}
</script>